import { createContext } from 'react';

const hostContext = createContext();

export default hostContext;
